import {Spinner, styled} from "tamagui";

const ThemedSpinner = styled(Spinner, {
        color: "$color"
    }
)
export {ThemedSpinner};
